import React from "react";
import { InPageEditableSectionField, TwoColumnInPageEditableSectionField } from "./types";
import { InPageEditableField } from "./InPageEditableField";
import { InPageHoverableField } from "./InPageHoverableField";
import classNames from "classnames";
import SupportQuestionMark from "supportbeacon/SupportQuestionMark";
import { TwoColumnInPageEditableField } from "./TwoColumnInPageEditableField";

interface Props {
  field: InPageEditableSectionField | TwoColumnInPageEditableSectionField
  compact: boolean
}

const InPageEditableFieldWithLabel = ({ field, compact }: Props) => {
  const hasSublabel = field.sublabel != null;
  const isTwoColumnField = "left" in field && "right" in field;

  return <>
    {!field.hideLabel && <div title={field.labelTitle} ref={field.ref} className={classNames("main-section-template-fields-label", field.labelClassName, {
      "flex gap": field.supportArticleId,
      "sublabel": hasSublabel
    })}>
      {field.label}
      {field.supportArticleId && <SupportQuestionMark small articleId={field.supportArticleId} />}
      {hasSublabel && <div className="s1_small">{field.sublabel}</div>}
    </div>}
    {!isTwoColumnField && (
      field.inPageEdit?.hoverEdit && field.isEmpty
        ? <InPageHoverableField compact={compact} field={field} />
        : <InPageEditableField compact={compact} field={field} />
    )}
    {isTwoColumnField && <TwoColumnInPageEditableField field={field} />}
  </>
}

export default InPageEditableFieldWithLabel;